import { Grid, Text } from '@servicetitan/anvil2';
import { fieldset } from './Fieldset.module.scss';
import { ReactNode } from 'react';

interface FieldsetProps extends React.HTMLAttributes<HTMLFieldSetElement> {
    children: ReactNode;
    legend?: string;
}

/*
 * Using fieldset element to group related elements in a form greatly improves the accessibility of the form
 * and makes it easier to test and maintain. This component is used to create a fieldset with a legend
 * but removes the default border and padding of the fieldset element.
 */
export const Fieldset = ({ children, legend, ...props }: FieldsetProps) => (
    <fieldset className={fieldset} {...props}>
        {legend != null ? (
            <legend>
                <Text variant="headline" size="small" el="h4" style={{ margin: 0 }}>
                    {legend}
                </Text>
            </legend>
        ) : null}
        <Grid
            md={{ templateColumns: 'repeat(auto-fill, minmax(360px, 1fr))' }}
            templateColumns="minmax(0, 1fr)"
            gap="4"
        >
            {children}
        </Grid>
    </fieldset>
);
